import {FITH2Symbol, ISymbolData, FITH2SymbolStates} from "./FITH2Symbol";
import {FireInTheHole2} from "../FireInTheHole2";
import {gsap} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";

export class FITH2Dirt extends FITH2Symbol {
    constructor(symbolData: ISymbolData, state: FITH2SymbolStates = FITH2SymbolStates.NORMAL) {
        super(symbolData);
    }

    public getTextureName(symName: string): string {
        return "D/D";
    }

    public getStateAnimation(state: FITH2SymbolStates = FITH2SymbolStates.NORMAL, duration: number = 0): gsap.core.Timeline {
        if (this._state === state) {
            return gsap.timeline();
        }
        this._state = state;
        const tl = gsap.timeline();
        const isBlur: boolean = (state === FITH2SymbolStates.BLUR);

        tl.add(() => {
            this._currentStateSprite.scale.set(isBlur?2:1);
            this._currentStateSprite.texture = FireInTheHole2.assetLoader.getTextures(`D${isBlur ? "_spin" : ""}`)[0];
            this._currentStateSprite.visible = true;
            this.addChild(this._currentStateSprite);
            this.addFrames(isBlur);
        }, 0);

        this._state = state;
        return tl;
    }

    public explode(winType: string): gsap.core.Timeline {
        this._isRemoved = true;
        const tl = gsap.timeline(),
            explodeEffect: TimelineSprite = new TimelineSprite(FireInTheHole2.assetLoader.getTextures("D_break/D_break_"));
        this.frames.forEach((frame: PIXI.Sprite) => {
            tl.add(gsap.to(frame, 0.3, {alpha: 0}), 0);
        });
        tl.add([
            () => {
                explodeEffect.anchor.set(0.5, 0.5);
                this.addChild(explodeEffect);
            },
            gsap.to(this._currentStateSprite, 0.3, {alpha: 0}),
            explodeEffect.getAnimationAutoShowHide()
        ], 0);
        tl.add(() => {
            this.removeChild(explodeEffect);
            this.remove();
        });
        return tl;
    }
}